<template>
  <v-container fluid>
    <v-row>
      <v-col>
        
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8">
        <v-row>
          <v-col  
            md="4" 
            v-for="(plan_, r1) in array_planes"
            v-if="plan_.estado =='ACTIVO'">
              <v-card class="plan"
                dense                 
              >
                <v-card-title class="pb-0 info "> <p> {{plan_.nombre}} </p></v-card-title>
                <v-card-text>
                  <br>
                  Estampado Anual : {{plan_.estampado_anual | millar}} <br>
                  Administradores : {{plan_.administradores | millar}} <br>
                  Usuarios asociados : {{plan_.operadores | millar}} <br>
                  Certificados : {{plan_.certificados | millar}} <br>
                  Correos : {{plan_.correos | millar}} <br>
                  Espacio disponible (GB) : {{plan_.espacio_disponible | millar}} <br>
                  Flujos : {{plan_.flujos | millar}} <br>
                  Tama&ntilde;o m&aacute;ximo de archivos (MB) : {{plan_.tamano_documentos | millar}} <br>
                  Tiempo de resguardo (d&iacute;as) : {{plan_.tiempo_resguardo | millar}} <br>
                </v-card-text>
                <v-card-actions>
                   <h1>Q. {{plan_.contrato_anual | dinero}} </h1>
                  <v-spacer></v-spacer>
                  <v-btn               
                    fab 
                    x-small 
                    class="mx-1" 
                    @click="addShoppingPlan(plan_)">
                    <v-icon left>mdi-cart-arrow-down</v-icon>
                  </v-btn>
                  <v-btn 
                    fab 
                    x-small 
                    class="mx-1" 
                    :disabled="plan_.recargas.length == 0"
                    @click="plan_.mostrar_recargas = !plan_.mostrar_recargas"
                    >
                    <v-icon>{{ plan_.mostrar_recargas ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-btn>
                </v-card-actions>
                <div v-show="plan_.mostrar_recargas" class="pa-3">
                  <v-divider></v-divider>
                  <v-card-title class="text-center">Recargas</v-card-title>
                  <v-card
                    flat
                    dense 
                    v-for="(recarga_, r1) in plan_.recargas"
                    v-if="recarga_.estado =='ACTIVO'"
                    :hover="true"
                    :class="`recarga_${recarga_.id} mb-1`">
                    <v-divider></v-divider>
                    <v-card-title class="pb-0">{{recarga_.descripcion}}</v-card-title>
                    <v-card-text>
                      <ul>
                        <li>Valor Q {{ recarga_.valor }}</li>
                      </ul>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn 
                        fab 
                        x-small 
                        class="mx-1" 
                        @click="addShoppingRecarga(recarga_)">
                        <v-icon left>mdi-cart-arrow-down</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-card>
          </v-col>
        </v-row>

        <v-dialog v-model="dialogForm" persistent max-width="700px">
          <v-card>
            <v-form                       
              ref="formPago" 
              v-model="validForm" 
              @submit.prevent="realizarCompra"
              lazy-validation>
              <v-card-title>
                <span class="headline">Datos para la factura</span>
              </v-card-title>
              <v-card-text>
                <!--<v-alert dense text type="info">
                  <ul>
                    <li>El link será enviado a su correo para realizar el pago.</li>
                  </ul>
                </v-alert>
                -->
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field 
                      v-model="correo"  
                      type="email" 
                      :rules="rules.email"
                      label="Correo" 
                      required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field 
                      v-model="nit"  
                      :rules="rules.nit"
                      label="Nit"
                      required>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn color="blue" text @click="dialogForm = false">Cerrar</v-btn>
                <v-spacer></v-spacer>
                <v-btn 
                  type="submit"
                  color="primary" 
                  :loading="loading"
                  :disabled="!validForm"                  
                  v-if="$store.state.user.shopping_total > 0">
                  Solicitar
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="12" class="mt-3" md="4">
        <v-card class="plan">
          <v-card-title class="info"><p> Detalle</p></v-card-title>
          
          
          <v-card-text>
            <v-list dense>
              <v-list-item v-for="(shopping_, p2) in $store.state.user.array_planes" :key="p2" link dense>
                <v-list-item-content>
                  <v-list-item-title>{{ shopping_.nombre}} Q {{ shopping_.contrato_anual }}</v-list-item-title>
                  <span>Plan</span>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="removePlan(shopping_, p2)">
                    <v-icon>mdi-close-thick</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-list dense>
              <v-list-item v-for="(shopping_, p3) in $store.state.user.array_recargas" :key="p3" link dense>
                <v-list-item-content>
                  <v-list-item-title>{{ shopping_.descripcion}} Q {{ shopping_.valor }}</v-list-item-title>
                  <span>Recarga</span>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="removeRecarga(shopping_, p3)">
                    <v-icon>mdi-close-thick</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <p class="display-1 text-center mb-0">
              Total Q {{ $store.state.user.shopping_total | dinero }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :loading="loading"
              :disabled="$store.state.user.shopping_total == 0"
              @click="dialogForm = true"
              >
              <v-icon>mdi-credit-card-outline</v-icon>
              Procesar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from "axios";
  
  export default {
    components: { 
    },
    data () {
      return {
        valid: true,
        dialog: false,
        selected_id: 0,
        array_rubricas: [],
        array_planes: [],
        array_recargas: [],
        vplan: [],
        nit:"CF",
        tab: null,
        loading: false,
        validForm: true,
        dialogForm: false,
        correo: this.$store.state.user.email,
        rules: {
          required: value => !!value || 'Requerido',
          min: v => v.length >= 8 || 'Min 8 caracteres',
          max: v => v.length <= 50 || 'Máximo 50 caracteres',
          email: [
            v => !!v || 'Correo requerido',
            v => /.+@.+\..+/.test(v) || 'Correo debe ser valido',
          ],
          nit: [
            v => !!v || 'Requerido', 
            v => (/^([0-9]+([0-9]|K|k){1})+$/.test(v) || /^((CF){1})+$/.test(v)) || 'Nit incorrecto'
          ],
        },
      }
    },
    computed: {
    },
    mounted() {
      console.log("carrito.vue");
      this.getPlanes();
    },
    methods: {
      getPlanes() {
        let getPlanes = axios.get('Plan/listar', { 'headers': this.$store.state.user.headers });
        return getPlanes.then((callback) =>
        {
          this.array_planes = callback.data;
        }).catch((error) => {
          console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      addShoppingPlan(item) {
        this.$store.state.user.shopping_total += item.contrato_anual;
        this.$store.state.user.array_planes.push(item);
      },
      removePlan(item, index) {
        this.$store.state.user.array_planes.splice(index, 1);
        this.$store.state.user.shopping_total -= item.contrato_anual;
      },
      addShoppingRecarga(item) {
        this.$store.state.user.shopping_total += item.valor;
        this.$store.state.user.array_recargas.push(item);
      },
      removeRecarga(item, index) {
        this.$store.state.user.array_recargas.splice(index, 1);
        this.$store.state.user.shopping_total -= item.valor;
      },
      realizarCompra(){
        let _this = this;
        _this.vplan = [];
        if (this.$refs.formPago.validate()) 
        {
          _this.$store.state.user.array_planes.forEach(function(item, index) {
            _this.vplan.push({
               "cantidad":1,
               "tipo_producto":"plan",
               "producto_id":item.id,
               "descripcion": item.nombre,
               "importe": item.contrato_anual,
               "codigo_esb":item.codigo_esb,
            })
          });
          _this.$store.state.user.array_recargas.forEach(function(item, index) {
            _this.vplan.push({
               "cantidad":1,
               "tipo_producto":"recarga",
               "producto_id":item.id,
               "descripcion": item.descripcion,
               "importe": item.valor,
               "codigo_esb":item.codigo_esb,
            })
          });
          this.loading = true;
          let vmdata = {
            "nit": this.nit,
            "correo_electronico": this.correo,   
            "importe_total": Number(this.$store.state.user.shopping_total),
            "compraDetalles": this.vplan,
          }
          let postcompra = axios.post('Compra/Crear', vmdata, { 'headers': this.$store.state.user.headers })
          return postcompra.then((callback) => {
            console.log(callback);
            if(callback.status == 201) {
              this.dialogForm = false;
              this.$store.state.user.shopping_total = 0;
              this.$store.state.user.array_recargas = [];
              this.$store.state.user.array_planes = [];
              //this.$refs.formPago.reset();
            } else {
              _this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: "Error en el proceso de compra" });
            }
            this.loading = false;
          }).catch((error) => {
            console.log(error)
            this.loading = false;
            _this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: error.response.data });
          });
        }
      },
    }
  }
</script>